import React from "react";
import { Box, Button, Typography } from "@mui/material";

const HorizontalTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: { xs: "10px", lg: "10px" }, 
        padding: { xs: "5px", lg: "5px" }, 
        backgroundColor: "#fff",
        borderRadius: "10px",
        alignItems: "center",
        border: "1px solid #eaeef3",
        width: {xs: 'max-content', lg: 'max-content'}, 
        maxWidth: "100%", 
        overflowX: "hidden",
        height: { xs: "auto", lg: "auto" },
        justifyContent: { xs: "flex-start", lg: "flex-start" },
      }}
    >
      {tabs.map((tab) => (
        <Box key={tab.label} sx={{ display: "flex", alignItems: "center", flexShrink: 1 }}>
          <Button
            onClick={() => !tab.comingSoon && onTabChange(tab.label)}
            sx={{
              borderRadius: "8px",
              fontSize: "14px",
              "@media (max-width: 400px)": {
                fontSize: "12px",
                padding: '8px 15px',
                minWidth: "80px",
              },
              "@media (max-width: 350px)": {
                fontSize: "11px",
                padding: '8px 10px',
                minWidth: "70px",
              },
              fontWeight: 600,
              cursor: tab.comingSoon ? "default" : "pointer",
              textTransform: "none",
              color: activeTab === tab.label ? "#fff" : "#222",
              // color: activeTab === tab.label ? "#fff" : (tab.label === 'Edit Design' ? "#999" : "#222"),
              backgroundColor: activeTab === tab.label ? "var(--brand-color)" : "transparent",
              "&:hover": {
                backgroundColor: activeTab === tab.label ? "var(--brand-color-hover)" : "transparent",
              },
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              flex: "1 1 auto", 
              minWidth: "100px", 
              gap: 0.5, 
              display: "flex",
              padding: '8px 20px',
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            {tab.label}
            {tab.comingSoon && (
              <Typography
                variant="caption"
                sx={{
                  backgroundColor: "#eaeef3",
                  color: "#bbb",
                  fontSize: "8px", 
                  "@media (max-width: 400px)": {
                    fontSize: "7px",
                  },
                  "@media (max-width: 350px)": {
                    fontSize: "6px",
                  },
                  padding: { xs: "1px 2px", lg: "2px 4px" },
                  borderRadius: "5px",
                  position: { xs: "absolute", lg: "static" },
                  top: { xs: "-6px", lg: "auto" },
                  right: { xs: "-8px", lg: "auto" },
                }}
              >
                Coming Soon
              </Typography>
            )}
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default HorizontalTabs;